import styled from 'styled-components';
import { WalletSelect } from 'components/Modal/ModalTransaction/ModalTransaction.styled';
import { ModalBackdrop, modalPanelDialog } from '../ModalPrimitives.styled';

export { ModalBackdrop };

export const ModalContainer = styled.div`
  ${modalPanelDialog}
  position: absolute;
  top: 50%;
  left: 50%;
  width: 80%;
  padding: 24px;
  transform: translate(-50%, -50%);
`;

export const CloseBtn = styled.button`
  position: absolute;
  right: 16px;
  top: 16px;
  background-color: transparent;
  border: none;
  cursor: pointer;

  transition: 250ms;

  :hover {
    transform: scale(1.2);
  }
`;

export const TitleText = styled.p`
  font-size: 12px;
  line-height: 1.5;
  text-align: center;
  color: ${p => p.theme.colors.text.text};
  letter-spacing: 0.04em;
  margin-left: 5px;
`;

export const BtnsContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const ConfirmBtn = styled.button`
  width: 130px;
  height: 42px;

  border: none;
  border-radius: 16px;
  cursor: pointer;
  font-size: 12px;
  line-height: 1.5;
  text-align: center;
  letter-spacing: 0.02em;

  color: #ffffff;
  background-color: ${p => p.theme.colors.main.orangeMain};
  box-shadow: ${p => p.theme.modal.ctaGlow};

  transition-property: transform;
  transition-duration: 250ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

  :hover {
    transform: scale(1.1);
  }
`;
export const HeaderWrap = styled(BtnsContainer)`
  align-items: center;
  margin-bottom: 24px;
`;
export const Label = styled.label`
  font-size: 10px;
  line-height: 1.5;
  letter-spacing: 0.04em;
  color: ${p => (p.$hasError ? '#ef4444' : p.theme.colors.text.text)};
  margin-bottom: 4px;
`;
export const Input = styled.input`
  color: ${p => p.theme.colors.text.text};
  border: none;
  font-size: 12px;
  line-height: 1.5;
  background: ${p => p.theme.colors.main.orangeLight};
  border-radius: 30px;
  border: 1px solid
    ${p => (p.$hasError ? '#ef4444' : 'transparent')};
  width: 100%;
  padding: 11px 16px;
  box-sizing: border-box;
  ::placeholder {
    color: ${p => p.theme.colors.text.gray};
  }
  :focus {
    outline: ${p => (p.$hasError ? '#ef4444' : p.theme.colors.main.orangeMain)};
    border: 1px solid
      ${p => (p.$hasError ? '#ef4444' : p.theme.colors.main.orangeMain)};
  }
`;
export const InputWrap = styled.div`
  margin-bottom: 24px;
`;
export const LanguageSelect = styled(WalletSelect)`
  .wallet-select__single-value {
    justify-content: flex-start;
  }
  .wallet-select__placeholder {
    text-align: start;
    margin: 0;
  }
  .wallet-select__control {
    margin-bottom: 24px;
    margin-top: 0;
    box-shadow: ${p =>
      p.$hasError
        ? '0 0 0 1px #ef4444'
        : p.theme.modal.chipNeutralShadow};
    border-color: ${p => (p.$hasError ? '#ef4444' : 'transparent')} !important;
  }
  .wallet-select__value-container {
    padding-left: 12px;
  }
`;
export const CurrencySelect = styled(LanguageSelect)``;
